/**
 * Product card for the New Arrivals grid.
 * Overlay visibility is handled in CSS via hover and focus-within.
 *
 * @extends {HTMLElement}
 */
class ArrivalsProductCard extends HTMLElement {}

if (!customElements.get('arrivals-product-card')) {
  customElements.define('arrivals-product-card', ArrivalsProductCard);
}
